module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0730.2df70e40.jpg";